import Seo from "@/components/Seo";
import { FadeUp } from "@/components/Reveal";
import { Eyebrow } from "@/components/shared";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: [
      "We collect information you provide directly to us when you fill out a form, contact us by phone or email, or otherwise communicate with Scherif Real Estate. This may include your name, email address, phone number, property preferences, and any other details you choose to share.",
      "We may also collect limited technical information automatically when you visit the site, such as your browser type, device, and pages visited.",
    ],
  },
  {
    title: "2. How We Use Information",
    body: [
      "We use the information we collect to respond to your inquiries, provide real estate services, communicate with you about properties and services you have expressed interest in, and improve our website and client experience.",
      "If you have opted in, we may also send you marketing and promotional messages. You may opt out at any time.",
    ],
  },
  {
    title: "3. Sharing of Information",
    body: [
      "We do not sell your personal information. We may share information with trusted service providers who assist us in operating our website and conducting our business, and as required by law or to protect our rights.",
      "Mobile information will not be shared with third parties or affiliates for marketing or promotional purposes.",
    ],
  },
  {
    title: "4. Cookies & Tracking",
    body: [
      "Our website may use cookies and similar technologies to understand how visitors use the site and to improve performance. You may set your browser to refuse cookies; some features of the site may not function properly as a result.",
    ],
  },
  {
    title: "5. Data Security",
    body: [
      "We take reasonable administrative, technical, and physical measures to protect the information you provide. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
    ],
  },
  {
    title: "6. Your Rights",
    body: [
      "You may request access to, correction of, or deletion of the personal information we hold about you, and you may opt out of marketing communications at any time by contacting us using the information below or by replying STOP to any text message.",
    ],
  },
  {
    title: "7. Children's Privacy",
    body: [
      "Our website and services are not directed to children under the age of 13, and we do not knowingly collect personal information from children.",
    ],
  },
  {
    title: "8. Changes to This Policy",
    body: [
      "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.",
    ],
  },
  {
    title: "9. Contact Us",
    body: ["If you have questions about this Privacy Policy, please contact us:"],
    contact: true,
  },
];

const Privacy = () => (
  <>
    <Seo
      title="Privacy Policy — Scherif Real Estate"
      siteName="Scherif Real Estate"
      description="Privacy Policy for Scherif Real Estate — how we collect, use, and protect your information."
    />
    <section className="container-luxe max-w-4xl pb-28 pt-36 sm:pt-48" data-testid="privacy-page">
      <FadeUp>
        <Eyebrow className="mb-5">Legal</Eyebrow>
        <h1 className="font-serif text-5xl font-light tracking-tight text-charcoal sm:text-6xl">Privacy Policy</h1>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-muted">Scherif Real Estate — Effective Date: 9/10/2025</p>
      </FadeUp>
      <div className="mt-16 space-y-12">
        {SECTIONS.map((s) => (
          <FadeUp key={s.title}>
            <h2 className="font-serif text-2xl font-light text-charcoal sm:text-3xl">{s.title}</h2>
            {s.body.map((p, i) => (
              <p key={i} className="mt-4 text-sm leading-[1.9] text-slate-muted">{p}</p>
            ))}
            {s.contact && (
              <div className="mt-6 border border-warm-border bg-stone-beige p-6">
                <p className="font-serif text-xl text-charcoal">Scherif Real Estate</p>
                <a href="mailto:scherifrealestate@gmail.com" className="link-underline mt-2 inline-block text-sm text-charcoal" data-testid="privacy-email">
                  scherifrealestate@gmail.com
                </a>
              </div>
            )}
          </FadeUp>
        ))}
      </div>
    </section>
  </>
);

export default Privacy;
